import { SET_PAGE_CONTENT_DYNAMIC_VALUES } from 'constants/reduxActions';

export default function dynamicPageContentValues(state = { dynamicValues: {} }, action) {
  const { type, dynamicValues: nextDynamicValues } = action;

  switch (type) {
    case SET_PAGE_CONTENT_DYNAMIC_VALUES:
      const { dynamicValues: previousDynamicValues = {} } = state;
      const dynamicValues = { ...previousDynamicValues, ...nextDynamicValues };
      return { ...state, dynamicValues };

    default:
      return state;
  }
}
